import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseKyuyohiSetting } from '@/repositories/fuzoku-meisai/junsoku/data'
import { Axios } from 'axios'
import { RootState } from '@/store'

export interface KyuyohiSettingRepository {
  list (): Promise<ResponseKyuyohiSetting>;

  save (param: ResponseKyuyohiSetting): Promise<ResponseKyuyohiSetting>;
}

type RequestParamItem = {
  doctor: Kamoku[];
  nurse: Kamoku[];
  therapist: Kamoku[];
  technician: Kamoku[];
  clerk: Kamoku[];
  skilledLaborer: Kamoku[];
  other: Kamoku[];
}

type RequestParam = {
  kyuryou: RequestParamItem;
  shouyo: RequestParamItem;
  shouyoHikiate: RequestParamItem;
  taishoku: RequestParamItem;
  fukuri: Kamoku[];
}

export class KyuyohiSettingRepositoryImpl implements KyuyohiSettingRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/kyuyohi`
    this.state = state
  }

  private readonly http: Axios
  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseKyuyohiSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseKyuyohiSetting): Promise<ResponseKyuyohiSetting> {
    const requestParam: RequestParam = {
      kyuryou: {
        doctor: param.kyuryou.doctor.targets,
        nurse: param.kyuryou.nurse.targets,
        therapist: param.kyuryou.therapist.targets,
        technician: param.kyuryou.technician.targets,
        clerk: param.kyuryou.clerk.targets,
        skilledLaborer: param.kyuryou.skilledLaborer.targets,
        other: param.kyuryou.other.targets
      },
      shouyo: {
        doctor: param.shouyo.doctor.targets,
        nurse: param.shouyo.nurse.targets,
        therapist: param.shouyo.therapist.targets,
        technician: param.shouyo.technician.targets,
        clerk: param.shouyo.clerk.targets,
        skilledLaborer: param.shouyo.skilledLaborer.targets,
        other: param.shouyo.other.targets
      },
      shouyoHikiate: {
        doctor: param.shouyoHikiate.doctor.targets,
        nurse: param.shouyoHikiate.nurse.targets,
        therapist: param.shouyoHikiate.therapist.targets,
        technician: param.shouyoHikiate.technician.targets,
        clerk: param.shouyoHikiate.clerk.targets,
        skilledLaborer: param.shouyoHikiate.skilledLaborer.targets,
        other: param.shouyoHikiate.other.targets
      },
      taishoku: {
        doctor: param.taishoku.doctor.targets,
        nurse: param.taishoku.nurse.targets,
        therapist: param.taishoku.therapist.targets,
        technician: param.taishoku.technician.targets,
        clerk: param.taishoku.clerk.targets,
        skilledLaborer: param.taishoku.skilledLaborer.targets,
        other: param.taishoku.other.targets
      },
      fukuri: param.fukuri.targets
    }
    const { data } = await this.http.post(this.baseUrl, requestParam)
    return data
  }
}
